<template>
  <section class="content">
    <BlockUI v-show="loadingShow">
      <div class="spinner-border text-info"></div>
      <p>شکیبا باشید...</p>
    </BlockUI>
    <div class="body_scroll">
      <div class="block-header">
        <div class="row">
          <div class="col-lg-7 col-md-6 col-sm-12">
            <h2>مدیریت حواله های خروجی</h2>
            <ul class="breadcrumb mt-3">
              <li class="breadcrumb-item">
                <a href="#" @click="$store.state.contentPane='Dashboard'">
                  <i class="zmdi zmdi-home"></i>پنل مدیریت
                </a>
              </li>

              <li class="breadcrumb-item active">
                <a href="#">مدیریت حواله های خروجی</a>
              </li>
              <li class="breadcrumb-item active">
                <a href="#" ref="BreadCrumbTitle"></a>
              </li>
            </ul>
            <button class="btn btn-primary btn-icon mobile_menu" type="button">
              <i class="zmdi zmdi-sort-amount-desc"></i>
            </button>
          </div>
          <div class="col-lg-5 col-md-6 col-sm-12 text-left">
            <button class="btn btn-primary float-right right_icon_toggle_btn" type="button">
              <i class="zmdi zmdi-arrow-right align-middle"></i>
            </button>
            <div class="dropdown float-left">
              <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                دسترسی
                <i class="zmdi zmdi-caret-down" style="vertical-align:middle;"></i>
              </button>
              <div class="dropdown-menu">
                <a class="dropdown-item" href="#" @click="panelActive='ProductionPlanningDashboard'">برنامه ریزی
                  تولید</a>
                <a class="dropdown-item" href="#" @click="panelActive='OrderingDashboard'">سفارش گذاری</a>
                <a class="dropdown-item" href="#" @click="panelActive='InspectorsDashboard'">بازرسی</a>
                <a class="dropdown-item" href="#" @click="panelActive='LogisticsDashboard'">شناسنامه ارسال محموله</a>
                <a class="dropdown-item" href="#" @click="panelActive='ShipmentDashboard'">کارتابل ارسال محموله</a>
              </div>
            </div>
            <!--            <button
                            class="btn btn-success float-right right_icon_toggle_btn"
                            type="button"
                            title="فروشگاه جدید"
                            data-color="red"
                            data-toggle="modal"
                            @click="openNewShopModal()"
                        >
                          <i class="zmdi zmdi-plus align-middle"></i>
                          فروشگاه جدید
                        </button>-->
            <!--            <button
                            class="btn btn-success float-right right_icon_toggle_btn"
                            type="button"
                            title="دانلود PDF لیست فروشگاه ها"
                            data-color="red"
                            data-toggle="modal"
                            @click="downloadShopList()"
                        >
                          <i class="zmdi zmdi-download align-middle"></i>
                          دانلود PDF لیست فروشگاه‌ها
                        </button>-->
            <!--            <button class="btn btn-primary float-right right_icon_toggle_btn" type="button"
                                @click="openNewContractModal">
                          قرارداد جدید
                        </button>-->
            <!--            <button class="btn btn-primary float-right right_icon_toggle_btn" type="button"
                                @click="openFindCustomerModal">
                          فیلتر گذاری
                        </button>-->
          </div>
        </div>
      </div>

      <div class="container-fluid">
<!--        <div class="row clearfix" v-if="panelActive==='OrderingDashboard'">
          <div class="col-lg-12">
            <div class="card">
              <div class="row pr-3">
                <form class="form-inline">
                  <div class="form-group mb-2">
                    <select v-model="pageSize" class="form-control">
                      <option value="10">10</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                </form>
              </div>
              <div class="card mt-2">
                <div class="card-header bg-info">
                  <div class="row">
                    <div class="col">
                      .:: فیلتر گذاری ::.
                    </div>
                    <div class="col text-left">
                      <a href="#" class="text-dark" @click="closeFilterPanel" style="text-align: left">
                        <small ref="a_CloseFilterPanel">
                          نمایش
                        </small>
                      </a>
                    </div>
                  </div>


                </div>
                <div class="card-body bg-white" v-if="isOpenFilterPanel">
                  <form @submit.prevent="startFilterPendingOrders">
                    <div class="row m-0 mb-2">
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">حواله سازنده</label>
                          <input type="text" class="form-control text-left" v-model="order.InvoiceNumber">
                        </div>
                      </div>
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">کد کالا</label>
                          <input type="text" class="form-control text-left">
                        </div>
                      </div>
                    </div>
                    <div class="row m-0 mb-2">
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">مشتری</label>
                          <select
                              class="form-control show-tick ms select2"
                              data-placeholder="انتخاب کنید"
                              style="height:auto;" v-model="filterPendingOrders.CustomerId">
                            <option v-for="(item,index) in customers" :key="index" :value="item._id">{{
                                item.CustomerTitle
                              }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">شماره فنی</label>
                          <input type="text" class="form-control text-left">
                        </div>
                      </div>
                    </div>
                    <div class="row m-0 mb-2">
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">محل تحویل</label>
                          <select
                              class="form-control show-tick ms select2"
                              data-placeholder="انتخاب کنید"
                              style="height:auto;" v-model="filterPendingOrders.WarehouseId">
                            <option v-for="(item,index) in warehouseList" :key="index" :value="item._id">
                              {{ item.WarehouseTitle }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">رسیدن به مقصد</label>
                          <div class="row">
                            <div class="col">
                              &lt;!&ndash;                              <input type="text" class="form-control text-left" v-model="order.EstimatedArrivalTime">&ndash;&gt;
                              <date-picker
                                  type="datetime"
                                  :autoSubmit="true"
                                  format="YYYY-MM-DD HH:mm"
                                  display-format="jYYYY/jMM/jDD-HH:mm"
                                  v-model="order.EstimatedArrivalTime" inputClass="form-control text-left"
                              ></date-picker>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                    <div class="row m-0 mb-2">
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">تامین کننده</label>
                          <select
                              class="form-control show-tick ms select2"
                              data-placeholder="انتخاب کنید"
                              style="height:auto;" v-model="filterPendingOrders.SupplierId">
                            <option value="678b97bab3f8164454040d18">
                              بهران موتور گلپایگان
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">توضیحات</label>
                          <input type="text" class="form-control text-right" v-model="order.OrderDescription">
                        </div>
                      </div>
                    </div>
                    <div class="row m-0 mb-2">
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">نوع خودرو</label>
                          <select
                              class="form-control show-tick ms select2"
                              data-placeholder="انتخاب کنید"
                              style="height:auto;" v-model="filterPendingOrders.VehicleId">
                            <option v-for="(item,index) in vehicleList" :key="index" :value="item._id">
                              {{ item.VehicleTitle }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>


                    <div class="row m-0 mb-2">
                      <div class="col text-right" style="direction: rtl;">
                        <button class="btn btn-primary" type="submit">
                          گزارش گیری
                        </button>
                        <button class="btn btn-success" type="button" v-if="order.Orders.length>0" @click="submitOrder">
                          تایید ارسال
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div class="body">

                <div class="table-responsive">
                  <table
                      class="table table-bordered table-hover"
                  >
                    <thead class="bg-info">
                    <tr>
                      <th class="text-center">ردیف</th>
                      <th class="text-center">انتخاب</th>
                      <th class="text-center">شرح قطعه</th>
                      <th class="text-center">شماره فنی</th>
                      <th class="text-center">کدکالا</th>
                      <th class="text-center">تعداد پالت</th>
                      <th class="text-center">نوع پالت</th>
                      <th class="text-center">وضعیت کیفی</th>
                      <th class="text-center">وضعیت موجودی</th>
                      <th class="text-center">زمان آزاد سازی</th>
                      <th class="text-center">زمان اعتبار</th>
                      <th class="text-center">شماره محموله</th>
                      &lt;!&ndash;                      <th class="text-center">درخواست ابطال</th>&ndash;&gt;
                      <th class="text-center">نام خودرو</th>
                      <th class="text-center">نام مشتری</th>
                      <th class="text-center">تعداد در پالت</th>
                      <th class="text-center">نوع ارسال</th>
                      <th class="text-center">تعداد</th>
                      <th class="text-center">تعداد ارسال</th>

                      <th class="text-center" style="white-space: nowrap;">عملیات</th>
                    </tr>
                    </thead>
                    &lt;!&ndash;                    <tfoot class="bg-info">
                                        </tfoot>&ndash;&gt;
                    <tbody class="text-center">
                    <tr v-if="pendingOrdersData.PendingOrderList.length===0">
                      <td class="p-3 align-middle" colspan="20">رکوردی برای نمایش وجود ندارد</td>
                    </tr>
                    <tr v-for="(item,index) in pendingOrdersData.PendingOrderList" :key="item._id"
                        :class="{ 'highlight': item.selected }">
                      <td class="p-1 align-middle">{{ index + 1 }}</td>
                      <td class="p-1 align-middle">
                        <input type="checkbox" style="height: 20px;width: 20px;" v-model="item.selected"
                               @change="addToOrderList(item, $event)">
                      </td>
                      <td class="p-1 align-middle">{{ item.PartDescription }}</td>
                      <td class="p-1 align-middle">{{ item.PartNumber }}</td>
                      <td class="p-1 align-middle">{{ item.ItemCode }}</td>
                      <td class="p-1 align-middle">{{ item.PalletQuantity }}</td>
                      <td class="p-1 align-middle">{{ item.PalletType }}</td>
                      <td class="p-1 align-middle">
                        <span class="text-success">
                          <i class="zmdi zmdi-flag"></i>
                        </span>
                      </td>
                      <td class="p-1 align-middle">
                        <span class="text-success">
                          <i class="zmdi zmdi-circle"></i>
                        </span>
                      </td>
                      <td class="p-1 align-middle">{{ item.ReleaseTime | moment("jYYYY/jM/jD-HH:mm") }}</td>
                      <td class="p-1 align-middle">{{ item.ValidTime | moment("jYYYY/jM/jD-HH:mm") }}</td>
                      <td class="p-1 align-middle">{{ item.ShipmentNumber }}</td>
                      &lt;!&ndash;<td class="p-1 align-middle">{{ item.asn_date_persian }}</td>&ndash;&gt;
                      <td class="p-1 align-middle">{{ item.VehicleDetail.VehicleTitle }}</td>
                      <td class="p-1 align-middle">{{ item.CustomerDetails.CustomerTitle }}</td>
                      <td class="p-1 align-middle">{{ item.QuantityPerPallet }}</td>
                      <td class="p-1 align-middle">{{ item.ShippingType }}</td>
                      <td class="p-1 align-middle">{{ item.Quantity }}</td>
                      <td class="p-1 align-middle">
                        <input type="number" class="form-control" :value="item.Quantity" min="1"
                               @input="updateOrderQuantity(item, $event.target.value)">
                      </td>
                      <td class="p-1 align-middle">
                        &lt;!&ndash;                        <a
                                                    href="#"
                                                    class="m-1 btn btn-primary btn-sm"
                                                    title="تایید محموله بدون بندیل"
                                                    @click="openEditContractModal(item)"
                                                >
                                                  <i class="zmdi zmdi-check align-middle text-white"></i>
                                                  تایید محموله بدون بندیل
                                                </a>
                                                <a
                                                    href="#"
                                                    class="m-1 btn btn-primary btn-sm"
                                                    title="تایید محموله با بندیل"
                                                    @click="openConfirmBundledShipmentModal(item)"
                                                >
                                                  <i class="zmdi zmdi-check align-middle text-white"></i>
                                                  تایید محموله با بندیل
                                                </a>&ndash;&gt;
                        <a
                            href="#"
                            class="m-1 btn btn-info btn-sm"
                            title="نمایش جزییات"
                            @click="openShipmentInfoModal(item)"
                        >
                          <i class="zmdi zmdi-eye align-middle text-white"></i>
                        </a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>-->
<!--        <div class="row clearfix" v-if="panelActive==='ProductionPlanningDashboard'">
          <div class="col-lg-12">
            <div class="card">
              <div class="row pr-3">
                <form class="form-inline">
                  <div class="form-group mb-2">
                    <select v-model="pageSize" class="form-control">
                      <option value="10">10</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                  <div class="form-group mx-sm-3 mb-2">
                    <button class="btn btn-success" type="button" @click="openNewPendingOrderModal">
                      <i class="zmdi zmdi-plus align-middle text-white"></i>
                      سفارش جدید
                    </button>
                  </div>
                  &lt;!&ndash;<button type="submit" class="btn btn-primary mb-2">Confirm identity</button>&ndash;&gt;
                </form>

              </div>
              <div class="card mt-2">
                <div class="card-header bg-info">
                  <div class="row">
                    <div class="col">
                      .:: فیلتر گذاری ::.
                    </div>
                    <div class="col text-left">
                      <a href="#" class="text-dark" @click="closeFilterPanel" style="text-align: left">
                        <small ref="a_CloseFilterPanel">
                          نمایش
                        </small>
                      </a>
                    </div>
                  </div>


                </div>
                <div class="card-body bg-white" v-if="isOpenFilterPanel">
                  <form @submit.prevent="startFilterPendingOrders">
                    <div class="row m-0 mb-2">
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">حواله سازنده</label>
                          <input type="text" class="form-control text-left" v-model="order.InvoiceNumber">
                        </div>
                      </div>
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">کد کالا</label>
                          <input type="text" class="form-control text-left">
                        </div>
                      </div>
                    </div>
                    <div class="row m-0 mb-2">
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">مشتری</label>
                          <select
                              class="form-control show-tick ms select2"
                              data-placeholder="انتخاب کنید"
                              style="height:auto;" v-model="filterPendingOrders.CustomerId">
                            <option v-for="(item,index) in customers" :key="index" :value="item._id">{{
                                item.CustomerTitle
                              }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">شماره فنی</label>
                          <input type="text" class="form-control text-left">
                        </div>
                      </div>
                    </div>
                    <div class="row m-0 mb-2">
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">محل تحویل</label>
                          <select
                              class="form-control show-tick ms select2"
                              data-placeholder="انتخاب کنید"
                              style="height:auto;" v-model="filterPendingOrders.WarehouseId">
                            <option v-for="(item,index) in warehouseList" :key="index" :value="item._id">
                              {{ item.WarehouseTitle }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">رسیدن به مقصد</label>
                          <div class="row">
                            <div class="col">
                              &lt;!&ndash;                              <input type="text" class="form-control text-left" v-model="order.EstimatedArrivalTime">&ndash;&gt;
                              <date-picker
                                  type="datetime"
                                  :autoSubmit="true"
                                  format="YYYY-MM-DD HH:mm"
                                  display-format="jYYYY/jMM/jDD-HH:mm"
                                  v-model="order.EstimatedArrivalTime" inputClass="form-control text-left"
                              ></date-picker>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                    <div class="row m-0 mb-2">
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">تامین کننده</label>
                          <select
                              class="form-control show-tick ms select2"
                              data-placeholder="انتخاب کنید"
                              style="height:auto;" v-model="filterPendingOrders.SupplierId">
                            <option value="678b97bab3f8164454040d18">
                              بهران موتور گلپایگان
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">توضیحات</label>
                          <input type="text" class="form-control text-right" v-model="order.OrderDescription">
                        </div>
                      </div>
                    </div>
                    <div class="row m-0 mb-2">
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">نوع خودرو</label>
                          <select
                              class="form-control show-tick ms select2"
                              data-placeholder="انتخاب کنید"
                              style="height:auto;" v-model="filterPendingOrders.VehicleId">
                            <option v-for="(item,index) in vehicleList" :key="index" :value="item._id">
                              {{ item.VehicleTitle }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>


                    <div class="row m-0 mb-2">
                      <div class="col text-right" style="direction: rtl;">
                        <button class="btn btn-primary" type="submit">
                          گزارش گیری
                        </button>
                        <button class="btn btn-success" type="button" v-if="order.Orders.length>0" @click="submitOrder">
                          تایید ارسال
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div class="body">

                <div class="table-responsive">
                  <table
                      class="table table-bordered table-hover"
                  >
                    <thead class="bg-info">
                    <tr>
                      <th class="text-center">ردیف</th>
                      <th class="text-center">انتخاب</th>
                      <th class="text-center">شرح قطعه</th>
                      <th class="text-center">شماره فنی</th>
                      <th class="text-center">کدکالا</th>
                      <th class="text-center">تعداد پالت</th>
                      <th class="text-center">نوع پالت</th>
                      <th class="text-center">وضعیت کیفی</th>
                      <th class="text-center">وضعیت موجودی</th>
                      <th class="text-center">زمان آزاد سازی</th>
                      <th class="text-center">زمان اعتبار</th>
                      <th class="text-center">شماره محموله</th>
                      &lt;!&ndash;                      <th class="text-center">درخواست ابطال</th>&ndash;&gt;
                      <th class="text-center">نام خودرو</th>
                      <th class="text-center">نام مشتری</th>
                      <th class="text-center">تعداد در پالت</th>
                      <th class="text-center">نوع ارسال</th>
                      <th class="text-center">تعداد</th>
                      <th class="text-center">تعداد ارسال</th>

                      <th class="text-center" style="white-space: nowrap;">عملیات</th>
                    </tr>
                    </thead>
                    &lt;!&ndash;                    <tfoot class="bg-info">
                                        </tfoot>&ndash;&gt;
                    <tbody class="text-center">
                    <tr v-if="pendingOrdersData.PendingOrderList.length===0">
                      <td class="p-3 align-middle" colspan="20">رکوردی برای نمایش وجود ندارد</td>
                    </tr>
                    <tr v-for="(item,index) in pendingOrdersData.PendingOrderList" :key="item._id"
                        :class="{ 'highlight': item.selected }">
                      <td class="p-1 align-middle">{{ index + 1 }}</td>
                      <td class="p-1 align-middle">
                        <input type="checkbox" style="height: 20px;width: 20px;" v-model="item.selected"
                               @change="addToOrderList(item, $event)">
                      </td>
                      <td class="p-1 align-middle">{{ item.PartDescription }}</td>
                      <td class="p-1 align-middle">{{ item.PartNumber }}</td>
                      <td class="p-1 align-middle">{{ item.ItemCode }}</td>
                      <td class="p-1 align-middle">{{ item.PalletQuantity }}</td>
                      <td class="p-1 align-middle">{{ item.PalletType }}</td>
                      <td class="p-1 align-middle">
                        <span class="text-success">
                          <i class="zmdi zmdi-flag"></i>
                        </span>
                      </td>
                      <td class="p-1 align-middle">
                        <span class="text-success">
                          <i class="zmdi zmdi-circle"></i>
                        </span>
                      </td>
                      <td class="p-1 align-middle">{{ item.ReleaseTime | moment("jYYYY/jM/jD-HH:mm") }}</td>
                      <td class="p-1 align-middle">{{ item.ValidTime | moment("jYYYY/jM/jD-HH:mm") }}</td>
                      <td class="p-1 align-middle">{{ item.ShipmentNumber }}</td>
                      &lt;!&ndash;<td class="p-1 align-middle">{{ item.asn_date_persian }}</td>&ndash;&gt;
                      <td class="p-1 align-middle">{{ item.VehicleDetail.VehicleTitle }}</td>
                      <td class="p-1 align-middle">{{ item.CustomerDetails.CustomerTitle }}</td>
                      <td class="p-1 align-middle">{{ item.QuantityPerPallet }}</td>
                      <td class="p-1 align-middle">{{ item.ShippingType }}</td>
                      <td class="p-1 align-middle">{{ item.Quantity }}</td>
                      <td class="p-1 align-middle">
                        <input type="number" class="form-control" :value="item.Quantity" min="1"
                               @input="updateOrderQuantity(item, $event.target.value)">
                      </td>
                      <td class="p-1 align-middle">
                        &lt;!&ndash;                        <a
                                                    href="#"
                                                    class="m-1 btn btn-primary btn-sm"
                                                    title="تایید محموله بدون بندیل"
                                                    @click="openEditContractModal(item)"
                                                >
                                                  <i class="zmdi zmdi-check align-middle text-white"></i>
                                                  تایید محموله بدون بندیل
                                                </a>
                                                <a
                                                    href="#"
                                                    class="m-1 btn btn-primary btn-sm"
                                                    title="تایید محموله با بندیل"
                                                    @click="openConfirmBundledShipmentModal(item)"
                                                >
                                                  <i class="zmdi zmdi-check align-middle text-white"></i>
                                                  تایید محموله با بندیل
                                                </a>&ndash;&gt;
                        <a
                            href="#"
                            class="m-1 btn btn-info btn-sm"
                            title="نمایش جزییات"
                            @click="openShipmentInfoModal(item)"
                        >
                          <i class="zmdi zmdi-eye align-middle text-white"></i>
                        </a>
                        &lt;!&ndash;                        <a
                                                    href="#"
                                                    class="m-1 btn btn-success btn-sm"
                                                    title="محاسبه اقساط"
                                                    @click="openCalcInstallmentModal(item)"
                                                >
                                                  <i class="zmdi zmdi-file align-middle text-white"></i>
                                                </a>
                                                <a
                                                    href="#"
                                                    class="m-1 btn btn-info btn-sm"
                                                    title="پرینت قرارداد"
                                                    @click="makeContractPDF(item)"
                                                >
                                                  <i class="zmdi zmdi-print align-middle text-white"></i>
                                                </a>
                                                <a
                                                    href="#"
                                                    class="m-1 btn btn-primary btn-sm"
                                                    title="بارگزاری فایل ها"
                                                    @click="openContractFileUploadModal(item)"
                                                >
                                                  <i class="zmdi zmdi-upload align-middle text-white"></i>
                                                </a>&ndash;&gt;
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>-->
<!--        <div class="row clearfix" v-if="panelActive==='InspectorsDashboard'">
          <div class="col-lg-12">
            <div class="card">
              <div class="row">
                <div class="col-lg-12">
                  <select v-model="pageSize">
                    <option value="10">10</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              </div>
              <div class="card mt-2">
                <div class="card-header bg-info">
                  <div class="row">
                    <div class="col">
                      .:: فیلتر گذاری ::.
                    </div>
                    <div class="col text-left">
                      <a href="#" class="text-dark" @click="closeFilterPanel" style="text-align: left">
                        <small ref="a_CloseFilterPanel">
                          نمایش
                        </small>
                      </a>
                    </div>
                  </div>


                </div>
                <div class="card-body bg-white" v-if="isOpenFilterPanel">

                  <form @submit.prevent="filterOrders">
                    <div class="row m-0 mb-2">
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">تامین کننده</label>
                          <select
                              class="form-control show-tick ms select2"
                              data-placeholder="انتخاب کنید"
                              style="height:auto;" v-model="filterOrder.SupplierId">

                            <option value="678b97bab3f8164454040d18">
                              تولیدی صنعتی بهران موتور گلپایگان
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">شماره ارسال محموله</label>
                          <input type="text" class="form-control text-left" v-model="filterOrder.ShipmentNumber">
                        </div>
                      </div>
                    </div>
                    <div class="row m-0 mb-2">
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">تاریخ تحویل</label>
                          <div class="row">
                            <div class="col">
                              <date-picker
                                  type="date"
                                  :autoSubmit="true"
                                  format="YYYY-MM-DD"
                                  display-format="jYYYY/jMM/jDD"
                                  v-model="filterOrder.FromDate" placeholder="از تاریخ"
                                  inputClass="form-control text-left"
                              ></date-picker>
                            </div>
                            <div class="col">
                              <date-picker
                                  type="date"
                                  :autoSubmit="true"
                                  format="YYYY-MM-DD"
                                  display-format="jYYYY/jMM/jDD"
                                  v-model="filterOrder.ToDate" placeholder="تا تاریخ"
                                  inputClass="form-control text-left"
                              ></date-picker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">وضعیت محموله</label>
                          <select
                              class="form-control show-tick ms select2"
                              data-placeholder="انتخاب کنید"
                              style="height:auto;" v-model="filterOrder.OrderStatus">

                            <option value="0">
                              تایید نشده
                            </option>
                            <option value="1">
                              تایید شده
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>


                    <div class="row m-0 mb-2">
                      <div class="col text-right" style="direction: rtl;">
                        <button class="btn btn-primary" type="submit">
                          گزارش گیری
                        </button>
                        &lt;!&ndash;                        <button class="btn btn-success" type="submit">
                                                  تایید ارسال
                                                </button>&ndash;&gt;
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div class="body">

                <div class="table-responsive">
                  <table
                      class="table table-bordered table-striped table-hover">
                    <thead class="bg-info">
                    <tr>
                      <th class="text-center">ردیف</th>
                      <th class="text-center">شماره ارسال محموله</th>
                      <th class="text-center">زمان ثبت محموله</th>
                      <th class="text-center">تامین کننده</th>
                      <th class="text-center">کد تامین کننده</th>
                      <th class="text-center">محل تحویل</th>
                      <th class="text-center">زمان تایید</th>
                      <th class="text-center">گواهی مرغوبیت</th>
                      <th class="text-center">جزئیات</th>
                    </tr>
                    </thead>
                    &lt;!&ndash;                    <tfoot class="bg-info">
                                        </tfoot>&ndash;&gt;
                    <tbody class="text-center">
                    <tr v-if="ordersData.OrderList.length===0">
                      <td class="p-3 align-middle" colspan="20">رکوردی برای نمایش وجود ندارد</td>
                    </tr>
                    <tr v-for="(item,index) in ordersData.OrderList" :key="index">
                      <td class="p-1 align-middle">{{ index + 1 }}</td>
                      <td class="p-1 align-middle">{{ item.ShipmentNumber }}</td>
                      <td class="p-1 align-middle">{{ item.CreatedAt | moment("jYYYY/jM/jD-HH:mm") }}</td>
                      <td class="p-1 align-middle">{{ item.SupplierDetail.SupplierTitle }}</td>
                      <td class="p-1 align-middle">{{ item.SupplierDetail.SupplierCode }}</td>
                      <td class="p-1 align-middle">{{ item.WarehouseDetail.WarehouseTitle }}</td>
                      <td class="p-1 align-middle">{{ item.ConfirmedAt | moment("jYYYY/jM/jD-HH:mm") }}</td>


                      <td class="p-1 align-middle">
                        <span class="text-success">
                          <a target="_blank"
                             :href="`http://localhost:3269/API/V1/Orders/GenerateQualityCertificate?OrderId=${item._id}`">
                            <i class="zmdi zmdi-flag" style="color: #1CBFD0;font-size: 25px;"></i>
                          </a>
                        </span>
                      </td>
                      <td class="p-1 align-middle">
                        <a @click="openReportTestModal(item.PendingOrder,item._id)" style="cursor: pointer;">
                          <i class="zmdi zmdi-menu" style="color: #1CBFD0;font-size: 25px;"></i>
                        </a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>-->
<!--        <div class="row clearfix" v-if="panelActive==='LogisticsDashboard'">
          <div class="col-lg-12">
            <div class="card">
              <div class="row">
                <div class="col-lg-12">
                  <form class="form-inline">
                    <div class="form-group mb-2">
                      <select v-model="pageSize" class="form-control">
                        <option value="10">10</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                    </div>
                  </form>

                </div>
              </div>
              <div class="card mt-2">
                <div class="card-header bg-info">
                  <div class="row">
                    <div class="col">
                      .:: شناسنامه حمل بار ::.
                    </div>
                    <div class="col text-left">
                      <a href="#" class="text-dark" @click="closeFilterPanel" style="text-align: left">
                        <small ref="a_CloseFilterPanel">
                          نمایش
                        </small>
                      </a>
                    </div>
                  </div>


                </div>
                <div class="card-body bg-white" v-if="isOpenFilterPanel">
                  <form @submit.prevent="submitWaybill">
                    <div class="row m-0 mb-2">
                      <div class="col-md-2 border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">نام و نام خانوادگی راننده</label>
                          <input type="text" class="form-control text-right" v-model="waybill.DriverFullName">
                        </div>
                      </div>
                      <div class="col-md-2 border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">موبایل راننده</label>
                          <input type="text" class="form-control text-left" style="direction: ltr;" maxlength="11"
                                 v-model="waybill.DriverMobile">
                        </div>
                      </div>
                      <div class="col-md-2 border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">خودرو</label>
                          <select
                              class="form-control show-tick ms select2"
                              data-placeholder="انتخاب کنید"
                              style="height:auto;" v-model="waybill.Vehicle">
                            <option value="کامیون">
                              کامیون
                            </option>
                            <option value="نیسان">
                              نیسان
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="row">
                          <div class="col">
                            <label class="form-label text-black pr-3">پلاک خودرو</label>
                            <div class="row p-3 pt-0" style="padding-top: 0px !important;">
                              <div class="col">
                                <input type="text" class="form-control text-left" style="direction: ltr;"
                                       v-model="waybill.VehiclePlate1">
                              </div>

                              <div class="col">
                                <input type="text" class="form-control text-left" style="direction: ltr;"
                                       v-model="waybill.VehiclePlate2">
                              </div>
                              <div class="col">
                                <select
                                    class="form-control show-tick ms select2"
                                    data-placeholder="انتخاب کنید"
                                    style="height:auto;" v-model="waybill.VehiclePlate3">
                                  <option value="الف">
                                    الف
                                  </option>
                                  <option value="ب">
                                    ب
                                  </option>
                                </select>
                              </div>
                              <div class="col">
                                <input type="text" class="form-control text-left" style="direction: ltr;"
                                       v-model="waybill.VehiclePlate4">
                              </div>
                            </div>

                          </div>

                        </div>

                      </div>
                    </div>
                    <div class="row m-0 mb-2">
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">شماره بارنامه</label>
                          <input type="text" class="form-control text-left" style="direction: ltr;"
                                 v-model="waybill.WaybillNumber">
                        </div>
                      </div>
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">خروج از کارخانه</label>
                          <div class="row">
                            <div class="col">
                              <date-picker
                                  type="datetime"
                                  :autoSubmit="true"
                                  format="YYYY-MM-DD"
                                  display-format="jYYYY/jMM/jDD-HH:mm"
                                  placeholder="انتخاب کنید"
                                  inputClass="form-control text-left" v-model="waybill.ExitTime"
                              ></date-picker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">پیش بینی رسیدن</label>
                          <div class="row">
                            <div class="col">
                              <date-picker
                                  type="datetime"
                                  :autoSubmit="true"
                                  format="YYYY-MM-DD"
                                  display-format="jYYYY/jMM/jDD-HH:mm"
                                  placeholder="انتخاب کنید"
                                  inputClass="form-control text-left" v-model="waybill.ArrivalTime"
                              ></date-picker>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row m-0 mb-2">
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">توضیحات</label>
                          <input type="text" class="form-control" v-model="waybill.Desc">
                        </div>
                      </div>
                    </div>


                    <div class="row m-0 mb-2">
                      <div class="col text-right" style="direction: rtl;">
                        <button class="btn btn-success" type="submit" v-if="waybill.Orders.length>0">
                          ثبت بارنامه
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div class="body">

                <div class="table-responsive">
                  <table
                      class="table table-bordered"
                  >
                    <thead class="bg-info">
                    <tr>
                      <th class="text-center">ردیف</th>
                      <th class="text-center"></th>
                      <th class="text-center">شماره ارسال محموله</th>
                      <th class="text-center">سازنده</th>
                      <th class="text-center">کد سازنده</th>
                      <th class="text-center">محل تحویل</th>
                      <th class="text-center">زمان تایید</th>
                    </tr>
                    </thead>
                    &lt;!&ndash;                    <tfoot class="bg-info">
                                        </tfoot>&ndash;&gt;
                    <tbody class="text-center">
                    <tr v-if="ordersNotInWaybillsData.OrdersNotInWaybillsList.length===0">
                      <td class="p-3 align-middle" colspan="20">رکوردی برای نمایش وجود ندارد</td>
                    </tr>
                    <tr v-for="(item,index) in ordersNotInWaybillsData.OrdersNotInWaybillsList" :key="index">
                      <td class="p-1 align-middle">{{ index + 1 }}</td>
                      <td class="p-1 align-middle">
                        <input type="checkbox" style="height: 20px;width: 20px;" v-model="item.selected"
                               @change="addToWaybill(item, $event)">
                      </td>
                      <td class="p-1 align-middle">
                        {{ item.ShipmentNumber }}
                      </td>
                      <td class="p-1 align-middle">{{ item.SupplierDetail.SupplierTitle }}</td>
                      <td class="p-1 align-middle">{{ item.SupplierDetail.SupplierCode }}</td>
                      <td class="p-1 align-middle">{{ item.WarehouseDetail.WarehouseTitle }}</td>
                      <td class="p-1 align-middle">{{ item.ConfirmedAt | moment("jYYYY/jM/jD-HH:mm") }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>-->
<!--        <div class="row clearfix" v-else-if="panelActive==='ShipmentDashboard'">
          <div class="col-lg-12">
            <div class="card">
              <div class="row">
                <div class="col-lg-12">
                  <form class="form-inline">
                    <div class="form-group mb-2">
                      <select v-model="pageSize" class="form-control">
                        <option value="10">10</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                    </div>
                  </form>

                </div>
              </div>
              <div class="card mt-2">
                <div class="card-header bg-info">
                  <div class="row">
                    <div class="col">
                      .:: کارتابل ارسال محموله ::.
                    </div>
                    <div class="col text-left">
                      <a href="#" class="text-dark" @click="closeFilterPanel" style="text-align: left">
                        <small ref="a_CloseFilterPanel">
                          نمایش
                        </small>
                      </a>
                    </div>
                  </div>


                </div>
                <div class="card-body bg-white" v-if="isOpenFilterPanel">
                  <form @submit.prevent="filterWaybills">
                    <div class="row m-0 mb-2">
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">مشتری</label>
                          <select
                              class="form-control show-tick ms select2"
                              data-placeholder="انتخاب کنید"
                              style="height:auto;" v-model="filterWaybill.CustomerId">
                            <option v-for="(item,index) in customers" :key="index" :value="item._id">
                              {{ item.CustomerTitle }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col border p-2 pt-1 pb-2 m-2">
                        <label class="form-label text-black">انبار</label>
                        <select class="form-control" v-model="filterWaybill.WarehouseId">
                          <option selected disabled>&#45;&#45;انتخاب کنید&#45;&#45;</option>
                          <option v-for="(item,index) in warehouseList" :key="index" :value="item._id">
                            {{ item.WarehouseTitle }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="row m-0 mb-2">
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">خروج از کارخانه</label>
                          <div class="row">
                            <div class="col">
                              <date-picker
                                  type="date"
                                  :autoSubmit="true"
                                  format="YYYY-MM-DD"
                                  display-format="jYYYY/jMM/jDD"
                                  placeholder="از تاریخ"
                                  inputClass="form-control text-left" v-model="filterWaybill.FromDate"
                              ></date-picker>
                            </div>
                            <div class="col">
                              <date-picker
                                  type="date"
                                  :autoSubmit="true"
                                  format="YYYY-MM-DD"
                                  display-format="jYYYY/jMM/jDD"
                                  placeholder="تا تاریخ"
                                  inputClass="form-control text-left" v-model="filterWaybill.ToDate"
                              ></date-picker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">شماره ارسال محموله</label>
                          <input type="text" class="form-control" v-model="filterWaybill.ShipmentNumber">
                        </div>
                      </div>
                    </div>

                    <div class="row m-0 mb-2">
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">وضعیت محموله</label>
                          <select
                              class="form-control show-tick ms select2"
                              data-placeholder="انتخاب کنید"
                              style="height:auto;" v-model="filterWaybill.OrderStatus">

                            <option value="1">
                              بازرسی شده
                            </option>
                            <option value="0">
                              بازرسی نشده
                            </option>
                            <option value="2">
                              ابطال شده
                            </option>
                            <option value="3">
                              مردود شده
                            </option>
                            <option value="4">
                              رسید شده
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">شماره حواله سازنده</label>
                          <input type="text" class="form-control" v-model="filterWaybill.InvoiceNumber">
                        </div>
                      </div>
                    </div>


                    <div class="row m-0 mb-2">
                      <div class="col text-right" style="direction: rtl;">
                        <button class="btn btn-success" type="submit">
                          گزارش بده
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div class="body">

                <div class="table-responsive">
                  <table
                      class="table table-bordered"
                  >
                    <thead class="bg-info">
                    <tr>
                      <th class="text-center">ردیف</th>
                      <th class="text-center">شماره ارسال محموله</th>
                      <th class="text-center">شماره حواله سازنده</th>
                      <th class="text-center">تاریخ تحویل</th>
                      <th class="text-center">سازنده</th>
                      <th class="text-center">کد سازنده</th>
                      <th class="text-center">مشتری</th>
                      <th class="text-center">محل تحویل</th>
                      <th class="text-center">برگه حمل</th>
                      <th class="text-center">گواهی مرغوبیت</th>
                      <th class="text-center">برچسب پالت</th>
                      <th class="text-center">عملیات</th>
                    </tr>
                    </thead>
                    &lt;!&ndash;                    <tfoot class="bg-info">
                                        </tfoot>&ndash;&gt;
                    <tbody class="text-center">
                    <tr v-if="[1].length===0">
                      <td class="p-3 align-middle" colspan="20">رکوردی برای نمایش وجود ندارد</td>
                    </tr>
                    <tr v-for="(item,index) in ordersData.OrderList" :key="index">
                      <td class="p-1 align-middle">{{ index + 1 }}</td>
                      <td class="p-1 align-middle">{{ item.ShipmentNumber }}</td>
                      <td class="p-1 align-middle">{{ item.InvoiceNumber }}</td>
                      <td class="p-1 align-middle">{{ item.EstimatedArrivalTime | moment("jYYYY/jM/jD") }}</td>
                      <td class="p-1 align-middle">{{ item.SupplierDetail.SupplierTitle }}</td>
                      <td class="p-1 align-middle">{{ item.SupplierDetail.SupplierCode }}</td>
                      <td class="p-1 align-middle">{{ item.CustomerDetails.CustomerTitle }}</td>
                      <td class="p-1 align-middle">{{ item.WarehouseDetail.WarehouseTitle }}</td>
                      <td class="p-1 align-middle">
                        <a style="cursor: pointer;"><i class="zmdi zmdi-file text-muted"
                                                       style="font-size: 20px;"></i></a>
                      </td>
                      <td class="p-1 align-middle">
                        <a style="cursor: pointer;"><i class="zmdi zmdi-file text-muted"
                                                       style="font-size: 20px;"></i></a>
                      </td>
                      <td class="p-1 align-middle">
                        <a style="cursor: pointer;"><i class="zmdi zmdi-file text-muted"
                                                       style="font-size: 20px;"></i></a>
                      </td>
                      <td class="p-1 align-middle">
                        <a style="cursor: pointer;"><i class="zmdi zmdi-edit text-muted"
                                                       style="font-size: 20px;"></i></a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>-->


        <!--<div class="row">
          <div class="col-md-12 text-center">
            <ul
                class="pagination pagination-warning d-flex flex-row justify-content-center align-items-center">
              <li
                  class="page-item"
                  v-for="item in pageList"
                  :key="item"
                  :class="{ 'active': pageIndex === item }">
                <a class="page-link" href="#" @click="getInstallments(item,pageSize)">{{ item }}</a>
              </li>
            </ul>
            <paginate
                :page-count="pageList"
                :click-handler="getInstallments"
                :prev-text="'prev'"
                :next-text="'next'" :page-range="10"
                :container-class="'custom-pagination'">
            </paginate>
          </div>
        </div>-->
      </div>
    </div>


    <!--        <div class="row clearfix" v-else-if="panelActive=='ProductionPlanningDashboard'">
          <div class="col-lg-12">
            <div class="card">
              &lt;!&ndash;              <div class="row">
                              <div class="col-lg-12">
                                <select v-model="pageSize">
                                  <option value="10">10</option>
                                  <option value="50">50</option>
                                  <option value="100">100</option>
                                </select>
                              </div>
                            </div>&ndash;&gt;
              <div class="card mt-2">
                <div class="card-header bg-info">
                  <div class="row">
                    <div class="col">
                      .:: بارگذاری ::.
                    </div>
                    &lt;!&ndash;                    <div class="col text-left">
                                          <a href="#" class="text-dark" @click="closeFilterPanel" style="text-align: left">
                                            <small ref="a_CloseFilterPanel">
                                              نمایش
                                            </small>
                                          </a>
                                        </div>&ndash;&gt;
                  </div>


                </div>
                <div class="card-body bg-white">
                  <form>
                    <div class="row m-0 mb-2">
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-6">
                          <label class="form-label text-black">فایل برنامه ریزی</label>
                          <div class="custom-file">
                            <input type="file" class="custom-file-input" id="fu_ProductionPlanning">
                            <label class="custom-file-label" for="fu_ProductionPlanning"
                                   style="text-align: left;direction: ltr;">انتخاب فایل اکسل برنامه ریزی</label>
                          </div>
                        </div>
                      </div>
                      &lt;!&ndash;                      <div class="col border p-0 pt-1 pb-2 m-2">
                                              <div class="col-md-6">
                                                <label class="form-label text-black">شماره ارسال محموله</label>
                                                <input type="text" class="form-control text-left">
                                              </div>
                                            </div>&ndash;&gt;
                    </div>
                    &lt;!&ndash;                    <div class="row m-0 mb-2">
                                          <div class="col border p-0 pt-1 pb-2 m-2">
                                            <div class="col-md-6">
                                              <label class="form-label text-black">تاریخ تحویل</label>
                                              <div class="row">
                                                <div class="col">
                                                  <input type="text" class="form-control text-left" maxlength="10" v-model="date"
                                                         @input="validateDate">
                                                </div>
                                                <div class="col">
                                                  <input type="text" class="form-control text-left" maxlength="10" v-model="date"
                                                         @input="validateDate">
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="col border p-0 pt-1 pb-2 m-2">
                                            <div class="col-md-6">
                                              <label class="form-label text-black">وضعیت محموله</label>
                                              <select
                                                  class="form-control show-tick ms select2"
                                                  data-placeholder="انتخاب کنید"
                                                  style="height:auto;">

                                                <option value="1400">
                                                  تایید نشده
                                                </option>
                                                <option value="1320">
                                                  تایید شده
                                                </option>
                                              </select>
                                            </div>
                                          </div>
                                        </div>&ndash;&gt;


                    <div class="row m-0 mb-2">
                      <div class="col text-right" style="direction: rtl;">
                        &lt;!&ndash;                        <button class="btn btn-primary" type="submit">
                                                  گزارش گیری
                                                </button>&ndash;&gt;
                        <button class="btn btn-success" type="submit">
                          بارگذاری کن
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              &lt;!&ndash;              <div class="body">
                              <div class="table-responsive">
                                <table
                                    class="table table-bordered table-striped table-hover"
                                >
                                  <thead class="bg-info">
                                  <tr>
                                    <th class="text-center">ردیف</th>
                                    <th class="text-center">شماره ارسال محموله</th>
                                    <th class="text-center">سازنده</th>
                                    <th class="text-center">کد سازنده</th>
                                    <th class="text-center">محل تحویل</th>
                                    <th class="text-center">زمان تایید</th>
                                    <th class="text-center">جزئیات</th>
                                    <th class="text-center">گواهی مرغوبیت</th>
                                  </tr>
                                  </thead>
                                  &lt;!&ndash;                    <tfoot class="bg-info">
                                                      </tfoot>&ndash;&gt;
                                  <tbody class="text-center">
                                  <tr v-if="installmentsData.InstallmentList.length===0">
                                    <td class="p-3 align-middle" colspan="20">رکوردی برای نمایش وجود ندارد</td>
                                  </tr>
                                  <tr v-for="(item,index) in installmentsData.InstallmentList" :key="item._id">
                                    <td class="p-1 align-middle">{{ index + 1 }}</td>
                                    <td class="p-1 align-middle">
                                      514256987
                                    </td>
                                    <td class="p-1 align-middle">{{ "تولیدی صنعتی بهران موتور گلپایگان" }}</td>
                                    <td class="p-1 align-middle">{{ "14863" }}</td>
                                    <td class="p-1 align-middle">{{ "انبار شماره 1 سایپا" }}</td>
                                    <td class="p-1 align-middle">{{ "1403/10/23-10:20" }}</td>
                                    <td class="p-1 align-middle">{{ "جزئیات" }}</td>
                                    <td class="p-1 align-middle">
                                      <span class="text-success">
                                        <i class="zmdi zmdi-flag"></i>
                                      </span>
                                    </td>
                                  </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>&ndash;&gt;
            </div>
          </div>
        </div>-->


<!--    <div class="modal fade" id="div_ReportTestModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
            <span class="title">گزارش تست</span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div>
                <form>
                  <div class="row m-0">
                    <div class="col-md-12">
                      <div class="table-responsive">
                        <table
                            class="table table-bordered table-striped table-hover">
                          <thead>
                          <tr>
                            <th class="text-center">ردیف</th>
                            <th class="text-center">شرح قطعه</th>
                            <th class="text-center">شماره فنی</th>
                            <th class="text-center">زمان آخرین ویرایش</th>
                            <th class="text-center">بارگذاری</th>
                          </tr>
                          </thead>

                          <tbody class="text-center">
                          <tr v-for="(item,index) in pendingOrderData.PendingOrderList" :key="index">
                            <td class="p-1 align-middle">{{ index + 1 }}</td>
                            <td class="p-1 align-middle">{{ item.PartDescription }}</td>
                            <td class="p-1 align-middle">{{ item.PartNumber }}</td>
                            <td class="p-1 align-middle">
                              <span v-if="item.UpdatedAt!=null">
                                {{ item.UpdatedAt | moment("jYYYY/jM/jD-HH:mm") }}
                              </span>

                            </td>
                            <td class="p-1 align-middle">
                              <a target="_blank" :href="`http://localhost:3269/TestReports/${item.TestReport}`"
                                 v-if="item.TestReport"
                                 class="btn btn-raised btn-warning btn-round waves-effect btn-sm">
                                مشاهده
                              </a>

                              <button @click.prevent="selectReportTestFile(item._id)"
                                      class="btn btn-raised btn-success btn-round waves-effect btn-sm"
                                      v-if="item.TestReport===null">
                                بارگذاری
                              </button>
                              <input
                                  type="file"
                                  ref="fileInput"
                                  style="display: none;" @change="uploadTestReport"
                              />
                              <button @click="removeTestReport(item._id)" type="button"
                                      class="btn btn-raised btn-danger btn-round waves-effect btn-sm"
                                      v-if="item.TestReport!==null">
                                حذف
                              </button>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </simplebar>

          </div>
          <div class="modal-footer">
            <div class="row">
              <div class="col text-right" style="direction: rtl;">
                <button class="btn btn-primary" @click="shipmentVerification">
                  تایید محموله
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>-->


    <div class="modal fade" id="div_AlertModal" tabindex="-1" role="dialog" style="z-index: 10000 !important;">
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header bg-info justify-content-between pt-1 pb-1">
            <span class="title text-white">پیغام سیستم</span>
            <span data-dismiss="modal" class="btn btn-link text-white pt-1">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div ref="div_AlertModalMessage"></div>
            </simplebar>
          </div>
        </div>
      </div>
    </div>


<!--    <div class="modal fade" id="div_NewPendingOrderModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
            <span class="title">محموله جدید</span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div>
                <form>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">شرح قطعه</label>
                      <input type="text" class="form-control text-right" v-model="newShipment.PartDescription">
                    </div>
                  </div>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">شماره فنی</label>
                      <input type="text" class="form-control text-left" style="direction: ltr;"
                             v-model="newShipment.PartNumber">
                    </div>
                  </div>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">کد کالا</label>
                      <input type="text" class="form-control text-left" style="direction: ltr;"
                             v-model="newShipment.ItemCode">
                    </div>
                  </div>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">تعداد پالت</label>
                      <input type="number" class="form-control text-left" style="direction: ltr;" min="1"
                             v-model="newShipment.PalletQuantity">
                    </div>
                  </div>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">نوع پالت</label>
                      <select class="form-control" v-model="newShipment.PalletType">
                        <option value="MS174">پالت نوع 1</option>
                        <option value="MS175">پالت نوع 2</option>
                        <option value="MS176">پالت نوع 3</option>
                      </select>
                    </div>
                  </div>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">زمان آزاد سازی</label>
                      <date-picker
                          type="datetime"
                          :autoSubmit="true"
                          format="YYYY-MM-DD HH:mm"
                          display-format="jYYYY/jMM/jDD-HH:mm" inputClass="form-control text-left"
                          v-model="newShipment.ReleaseTime"
                      ></date-picker>
                    </div>
                  </div>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">زمان اعتبار</label>
                      <date-picker
                          type="datetime"
                          :autoSubmit="true"
                          format="YYYY-MM-DD HH:mm"
                          display-format="jYYYY/jMM/jDD-HH:mm" inputClass="form-control text-left"
                          v-model="newShipment.ValidTime"
                      ></date-picker>
                    </div>
                  </div>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">شماره محموله</label>
                      <input type="text" class="form-control text-left" style="direction: ltr;"
                             v-model="newShipment.ShipmentNumber">
                    </div>
                  </div>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">مشتری</label>
                      <select class="form-control" v-model="newShipment.CustomerId">
                        <option selected disabled>&#45;&#45;انتخاب کنید&#45;&#45;</option>
                        <option v-for="(item,index) in customers" :key="index" :value="item._id">{{
                            item.CustomerTitle
                          }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">انبار</label>
                      <select class="form-control" v-model="newShipment.WarehouseId">
                        <option selected disabled>&#45;&#45;انتخاب کنید&#45;&#45;</option>
                        <option v-for="(item,index) in warehouseList" :key="index" :value="item._id">{{
                            item.WarehouseTitle
                          }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">خودرو</label>
                      <select class="form-control" v-model="newShipment.VehicleId">
                        <option selected disabled>&#45;&#45;انتخاب کنید&#45;&#45;</option>
                        <option v-for="(item,index) in vehicleList" :key="index" :value="item._id">{{
                            item.VehicleTitle
                          }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">نوع ارسال</label>
                      <select class="form-control" v-model="newShipment.ShippingType">
                        <option value="کانبان مشتری">کانبان مشتری</option>
                      </select>
                    </div>
                  </div>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">تعداد در پالت</label>
                      <input type="number" class="form-control text-left" style="direction: ltr;"
                             v-model="newShipment.QuantityPerPallet">
                    </div>
                  </div>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">تعداد</label>
                      <input type="number" class="form-control text-left" style="direction: ltr;"
                             v-model="newShipment.Quantity">
                    </div>
                  </div>
                </form>
              </div>
            </simplebar>

          </div>
          <div class="modal-footer">
            <div class="row">
              <div class="col text-right" style="direction: rtl;text-align: right;">
                <button class="btn btn-success" @click="addNewPendingOrder">
                  ثبت محموله
                </button>
                <button class="btn btn-danger" data-dismiss="modal">
                  انصراف
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>-->


  </section>
</template>
<script>
/* eslint-disable */
import axios from "axios";
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
// import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Paginate from "vuejs-paginate";
// import Vue from 'vue';
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

// import moment from "vue-moment-jalaali";
// import VueUploadMultipleImage from 'vue-upload-multiple-image';
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";


export default {
  data() {
    return {
      isOpenFilterPanel: false,
      panelActive: "",
      filterPendingOrders: {
        CustomerId: null,
        WarehouseId: null,
        SupplierId: null,
        VehicleId: null
      },
      order: {
        Orders: [],
        InvoiceNumber: null,
        EstimatedArrivalTime: null,
        OrderDescription: null,
        CustomerId: null,
        WarehouseId: null,
        SupplierId: null,
        VehicleId: null
      },
      filterOrder: {
        FromDate: null,
        ToDate: null,
        SupplierId: null,
        OrderStatus: null,
        ShipmentNumber: ""
      },
      ordersData: {OrderList: [], OrdersCount: 0},
      pendingOrderData: {PendingOrderList: [], PendingOrderCount: 0},
      ordersNotInWaybillsData: {OrdersNotInWaybillsList: [], OrdersNotInWaybillsCount: 0},
      uploadTestFile: {
        OrderId: null,
        ItemId: null,
        TestReportFile: null
      },
      customers: [],
      vehicleList: [],
      warehouseList: [],
      newShipment: {
        CustomerId: null,
        WarehouseId: null,
        VehicleId: null,
        PartDescription: null,
        PartNumber: null,
        ItemCode: null,
        PalletQuantity: 1,
        PalletType: null,
        ReleaseTime: null,
        ValidTime: null,
        ShipmentNumber: null,
        QuantityPerPallet: 1,
        ShippingType: null,
        Quantity: 1,
        QuantityShipped: 1
      },
      waybill: {
        DriverFullName: null,
        DriverMobile: null,
        Vehicle: null,
        VehiclePlate: null,
        VehiclePlate1: null,
        VehiclePlate2: null,
        VehiclePlate3: null,
        VehiclePlate4: null,
        WaybillNumber: null,
        ExitTime: null,
        ArrivalTime: null,
        Desc: null,
        Orders: [],
      },
      filterWaybill: {
        CustomerId: null,
        WarehouseId: null,
        FromDate: null,
        ToDate: null,
        OrderStatus: null,
        ShipmentNumber: null,
        InvoiceNumber: null
      },


      date: "",
      userInfo: {},
      filterFields: {
        FromDate: null,
        ToDate: null,
        SelectFilter: "DateRange",
        BOLNumber: null
      },
      loadingShow: false,
      pageSize: 10,
      pageList: 0,
      pageIndex: undefined,
      pendingOrdersData: {PendingOrderList: [], PendingOrdersCount: 0},
      shipmentConfirmationFields: {
        BillLading: null,
        SuppCode: null,
        DeliverSuppCode: null,
        AsnNo: null,
        ItemCode: null,
        // ContNo: null,
        // CaseNo: null,
        AppItemQty: null,
        RejItemQty: null,
        ItemRefDoc: null,
        ItemRefDate: null
        // RegisterType:"Bundled"
      },
      shipmentFields: {}

    };
  },
  methods: {
    filterWaybills() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios.post("/API/V1/Waybills/FilterOrders",self.filterWaybill, {
        headers: {
          Authorization: userInfo.Token
        }
      })
          .then(function (res) {
            let {Status, Message, Data} = res.data;
            console.log(res.data);
            if (Status === 1) {
              self.ordersData.OrderList = Data.OrderList
            } else {
              self.$refs.div_AlertModalMessage.innerHTML = Message;
              $("#div_AlertModal").modal({backdrop: "static"});
            }
          })
          .catch(function (error) {
            console.log(error);
            self.loadingShow = false;

          })
          .finally(function (res) {
            self.loadingShow = false;
          });
    },
    openNewPendingOrderModal() {
      let self = this;
      self.getCustomersInfo();
      $("#div_NewPendingOrderModal").modal({backdrop: "static"});
    },
    addNewPendingOrder() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      // self.uploadTestFile.ItemId = itemId;
      axios.post("/API/V1/PendingOrders/AddNewPendingOrder", self.newShipment, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: userInfo.Token
        }
      })
          .then(function (res) {
            let {Data, Message, Status} = res.data;
            console.log(res.data);

            if (Status === 1) {
              self.loadingShow = false;
              // $("#div_ReportTestModal").modal("hide");


              self.$toast.open({
                position: "bottom-right",
                message: Message,
                type: "success",
                duration: 5000
              });
            } else {
              self.loadingShow = false;
              self.$refs.div_AlertModalMessage.innerHTML = Message;
              $("#div_AlertModal").modal({backdrop: "static"});
            }
          })
          .catch(function (error) {
            console.log(error);
            self.loadingShow = false;
          })
          .finally(function (res) {
            self.loadingShow = false;
          });
    },
    getCustomersInfo() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios.get("/API/V1/Customers/GetCustomers", {
        headers: {
          'Content-Type': 'application/json',
          Authorization: userInfo.Token
        }
      })
          .then(function (res) {
            let {Data, Message, Status} = res.data;
            console.log(res.data);

            if (Status === 1) {
              self.loadingShow = false;
              self.customers = Data.Customers;
            } else {
              self.loadingShow = false;
              self.$refs.div_AlertModalMessage.innerHTML = Message;
              $("#div_AlertModal").modal({backdrop: "static"});
            }
          })
          .catch(function (error) {
            console.log(error);
            self.loadingShow = false;
          })
          .finally(function (res) {
            self.loadingShow = false;
          });
    },
    shipmentVerification() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      // self.uploadTestFile.ItemId = itemId;
      axios.post("/API/V1/Orders/ShipmentVerification", self.uploadTestFile, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: userInfo.Token
        }
      })
          .then(function (res) {
            let {Data, Message, Status} = res.data;
            console.log(Data);

            if (Status === 1) {
              self.loadingShow = false;
              $("#div_ReportTestModal").modal("hide");
              self.filterOrders();
              /*const itemToUpdate = self.pendingOrderData.PendingOrderList.find(item => item._id === Data.ItemId);
              if (itemToUpdate) {
                itemToUpdate.TestReport = null;
                itemToUpdate.UpdatedAt = Data.UpdatedAt
              }*/
              self.$toast.open({
                position: "bottom-right",
                message: Message,
                type: "success",
                duration: 5000
              });
            } else {
              self.loadingShow = false;
              self.$refs.div_AlertModalMessage.innerHTML = Message;
              $("#div_AlertModal").modal({backdrop: "static"});
            }
          })
          .catch(function (error) {
            console.log(error);
            self.loadingShow = false;
          })
          .finally(function (res) {
            self.loadingShow = false;
          });
    },
    removeTestReport(itemId) {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      self.uploadTestFile.ItemId = itemId;
      axios.post("/API/V1/Orders/RemoveTestReport", self.uploadTestFile, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: userInfo.Token
        }
      })
          .then(function (res) {
            let {Data, Message, Status} = res.data;
            console.log(Data);

            if (Status === 1) {
              self.loadingShow = false;
              const itemToUpdate = self.pendingOrderData.PendingOrderList.find(item => item._id === Data.ItemId);
              if (itemToUpdate) {
                itemToUpdate.TestReport = null;
                itemToUpdate.UpdatedAt = Data.UpdatedAt
              }
              self.$toast.open({
                position: "bottom-right",
                message: Message,
                type: "success",
                duration: 5000
              });
            } else {
              self.loadingShow = false;
              self.$refs.div_AlertModalMessage.innerHTML = Message;
              $("#div_AlertModal").modal({backdrop: "static"});
            }
          })
          .catch(function (error) {
            console.log(error);
            self.loadingShow = false;
          })
          .finally(function (res) {
            self.loadingShow = false;
          });
    },
    uploadTestReport(event) {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      const testReportFile = event.target.files[0];
      console.log(testReportFile);
      const formData = new FormData();
      formData.append('TestReportFile', testReportFile);
      formData.append('OrderId', self.uploadTestFile.OrderId);
      formData.append('ItemId', self.uploadTestFile.ItemId);
      axios.post("/API/V1/Orders/UploadTestReport", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: userInfo.Token
        }
      })
          .then(function (res) {
            let {Data, Message, Status} = res.data;
            console.log(Data);

            if (Status === 1) {
              self.loadingShow = false;
              const itemToUpdate = self.pendingOrderData.PendingOrderList.find(item => item._id === Data.ItemId);
              if (itemToUpdate) {
                itemToUpdate.TestReport = Data.FileName;
                itemToUpdate.UpdatedAt = Data.UpdatedAt;
              }
              self.$toast.open({
                position: "bottom-right",
                message: Message,
                type: "success",
                duration: 5000
              });

            } else {
              self.loadingShow = false;
              self.$refs.div_AlertModalMessage.innerHTML = Message;
              $("#div_AlertModal").modal({backdrop: "static"});
            }
          })
          .catch(function (error) {
            console.log(error);
            self.loadingShow = false;
          })
          .finally(function (res) {
            self.loadingShow = false;
          });
    },
    selectReportTestFile(itemId) {
      let self = this;
      self.uploadTestFile.ItemId = itemId;
      // console.log(this.$refs)
      this.$refs.fileInput[0].click();
    },
    openReportTestModal(pendingOrder, orderId) {
      let self = this;
      self.uploadTestFile.OrderId = orderId;
      self.pendingOrderData.PendingOrderList = pendingOrder;
      $("#div_ReportTestModal").modal("show");
    },
    closeFilterPanel() {
      let self = this;
      self.isOpenFilterPanel = !self.isOpenFilterPanel;
      self.$refs.a_CloseFilterPanel.innerText = self.isOpenFilterPanel === true ? "بستن" : "نمایش";
    },
    startFilterPendingOrders() {
      let self = this;
      self.getPendingOrders()
    },
    addToOrderList(item, event) {
      let self = this;
      console.log(item);
      if (event.target.checked) {
        self.order.Orders.push({OrderId: item._id, Quantity: parseInt(item.Quantity)});
      } else {
        self.order.Orders = self.order.Orders.filter(i => i.OrderId !== item._id);
      }
      console.log(self.order);
    },
    updateOrderQuantity(item, value) {
      let self = this;
      const index = self.order.Orders.findIndex(i => i.OrderId === item._id);
      if (index > -1) {
        self.order.Orders[index].Quantity = parseInt(value);
      }
      console.log(self.order);
    },
    submitOrder() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios.post("/API/V1/Orders/SubmitOrder", self.order, {
        headers: {
          "Content-Type": "application/json",
          Authorization: userInfo.Token
        }
      })
          .then(function (res) {
            let {Data, Message, Status} = res.data;
            console.log(Data);

            if (res.data.Status === 1) {
              self.loadingShow = false;
              self.order = {
                Orders: [],
                InvoiceNumber: null,
                EstimatedArrivalTime: null,
                OrderDescription: null,
                CustomerId: null,
                WarehouseId: null,
                SupplierId: null,
                VehicleId: null
              }
              self.$refs.div_AlertModalMessage.innerHTML = `<h5 class="text-success text-center">محموله جدید با موفقیت ثبت شد</h5><p>شماره محموله : ${Data.DeclarationNumber}</p><p>شماره اظهارنامه: ${Data.ShipmentNumber}</p>`;
              $("#div_AlertModal").modal({backdrop: "static"});
            } else {
              /*self.$toast.open({
                position: "bottom-right",
                message: Message,
                type: "error",
                duration: 5000
              });*/
              self.loadingShow = false;
              self.$refs.div_AlertModalMessage.innerHTML = Message;
              $("#div_AlertModal").modal({backdrop: "static"});
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (res) {
            self.loadingShow = false;
          });
    },
    filterOrders() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios.get("/API/V1/Orders/FilterOrders", {
        params: self.filterOrder,
        headers: {
          Authorization: userInfo.Token
        }
      })
          .then(function (res) {
            let {Status, Message, Data} = res.data;
            console.log(res.data);
            if (Status === 1) {
              self.ordersData.OrderList = Data.OrderList
            } else {
              self.$refs.div_AlertModalMessage.innerHTML = Message;
              $("#div_AlertModal").modal({backdrop: "static"});
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (res) {
            self.loadingShow = false;
          });
    },
    getPendingOrders(pageIndex = 1, limit = 10) {
      let self = this;
      self.pageIndex = pageIndex;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios
          .get("/API/V1/PendingOrders/FilterPendingOrders", {
            params: self.filterPendingOrders,
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (res) {
            console.log(res.data);
            let {Data, Status, Message} = res.data;
            if (Status === 1) {
              self.pendingOrdersData.PendingOrderList = Data.PendingOrders;
            } else {
              self.$refs.div_AlertModalMessage.innerHTML = Message;
              $("#div_AlertModal").modal({backdrop: "static"});
            }
            /*self.installmentsData.InstallmentsCount = res.data.Data.InstallmentsCount;
            let pageCount =
                self.installmentsData.InstallmentsCount % self.pageSize === 0
                    ? self.installmentsData.InstallmentsCount / self.pageSize
                    : self.installmentsData.InstallmentsCount / self.pageSize + 1;
            self.pageList = Math.floor(pageCount);*/
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function () {
            self.loadingShow = false;
          });
    },
    getOrdersNotInWaybills(pageIndex = 1, limit = 10) {
      let self = this;
      self.pageIndex = pageIndex;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios
          .get("/API/V1/Waybills/GetOrdersNotInWaybills", {
            params: null,
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (res) {
            console.log(res.data);
            let {Data, Status, Message} = res.data;
            if (Status === 1) {
              self.ordersNotInWaybillsData.OrdersNotInWaybillsList = Data.OrderList;
            } else {
              self.$refs.div_AlertModalMessage.innerHTML = Message;
              $("#div_AlertModal").modal({backdrop: "static"});
            }
            /*self.installmentsData.InstallmentsCount = res.data.Data.InstallmentsCount;
            let pageCount =
                self.installmentsData.InstallmentsCount % self.pageSize === 0
                    ? self.installmentsData.InstallmentsCount / self.pageSize
                    : self.installmentsData.InstallmentsCount / self.pageSize + 1;
            self.pageList = Math.floor(pageCount);*/
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function () {
            self.loadingShow = false;
          });
    },
    addToWaybill(item, event) {
      let self = this;
      console.log(item);
      if (event.target.checked) {
        self.waybill.Orders.push(item._id);
      } else {
        self.waybill.Orders = self.waybill.Orders.filter(i => i !== item._id);
      }
      console.log(self.waybill);
    },
    submitWaybill() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      self.waybill.VehiclePlate = [self.waybill.VehiclePlate1, self.waybill.VehiclePlate2, self.waybill.VehiclePlate3, self.waybill.VehiclePlate4].join('');
      axios.post("/API/V1/Waybills/SubmitWaybill", self.waybill, {
        headers: {
          "Content-Type": "application/json",
          Authorization: userInfo.Token
        }
      })
          .then(function (res) {
            let {Data, Message, Status} = res.data;
            console.log(Data);

            if (Status === 1) {
              self.loadingShow = false;
              self.getOrdersNotInWaybills();
              self.$refs.div_AlertModalMessage.innerHTML = `<h5 class="text-success text-center">بارنامه جدید با موفقیت ثبت شد</h5><p>شماره بارنامه : ${Data.WaybillNumber}</p>`;
              $("#div_AlertModal").modal({backdrop: "static"});
            } else {

              self.loadingShow = false;
              self.$refs.div_AlertModalMessage.innerHTML = Message;
              $("#div_AlertModal").modal({backdrop: "static"});
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (res) {
            self.loadingShow = false;
          });
    },
    /*validateDate() {
      let self = this;
      const regex = /^\d{0,4}\/?\d{0,2}\/?\d{0,2}$/;
      if (!regex.test(this.date)) {
        self.date = self.date.slice(0, -1);
      }
    }*/
  },
  created() {
    let self = this;
    self.panelActive = "OrderingDashboard";
    // self.getPendingOrders();
    // self.date=moment(Date.now(), "YYYY/MM/DD").format("jYYYY/jMM/jDD")
    // self.getInstallments();

  },
  watch: {
    /*pageSize: function (val) {
      this.getInstallments(this.pageIndex, this.pageSize);
    },*/
    "filterPendingOrders.VehicleId": function (newValue, oldValue) {
      this.order.VehicleId = newValue;
    },
    "filterPendingOrders.SupplierId": function (newValue, oldValue) {
      this.order.SupplierId = newValue;
    },
    "filterPendingOrders.WarehouseId": function (newValue, oldValue) {
      this.order.WarehouseId = newValue;
    },
    "filterPendingOrders.CustomerId": function (newValue, oldValue) {
      this.order.CustomerId = newValue;
      let customerFilter = this.customers.filter(item => item._id === newValue);
      console.log(customerFilter);
      if (customerFilter !== null && customerFilter !== undefined && customerFilter.length > 0) {
        this.vehicleList = customerFilter[0].VehiclesList;
        this.warehouseList = customerFilter[0].WarehouseList;
      }
    },
    "newShipment.CustomerId": function (newValue, oldValue) {
      let customerFilter = this.customers.filter(item => item._id === newValue);
      console.log(customerFilter);
      if (customerFilter !== null && customerFilter !== undefined && customerFilter.length > 0) {
        this.vehicleList = customerFilter[0].VehiclesList;
        this.warehouseList = customerFilter[0].WarehouseList;
      }
    },
    "panelActive": function (newValue, oldValue) {
      if (newValue === "LogisticsDashboard") {
        this.$refs.BreadCrumbTitle.innerText = "حمل و نقل";
        this.getOrdersNotInWaybills();
      } else if (newValue === "InspectorsDashboard") {
        this.$refs.BreadCrumbTitle.innerText = "بازرسی";
      } else if (newValue === "OrderingDashboard") {
        this.$refs.BreadCrumbTitle.innerText = "سفارش گذاری";
        this.getCustomersInfo();
      } else if (newValue === "ProductionPlanningDashboard") {
        this.$refs.BreadCrumbTitle.innerText = "برنامه ریزی تولید";
      } else if (newValue === "ShipmentDashboard") {
        this.$refs.BreadCrumbTitle.innerText = "کارتابل ارسال محموله";
        this.getCustomersInfo();
      }
    },
    "filterWaybill.CustomerId": function (newValue, oldValue) {
      this.order.CustomerId = newValue;
      let customerFilter = this.customers.filter(item => item._id === newValue);
      // console.log(customerFilter);
      if (customerFilter !== null && customerFilter !== undefined && customerFilter.length > 0) {
        // this.vehicleList = customerFilter[0].VehiclesList;
        this.warehouseList = customerFilter[0].WarehouseList;
      }
    }
  },
  components: {
    simplebar, 'paginate': Paginate, datePicker: VuePersianDatetimePicker,
  }
};
</script>

<style>
.vs__search::placeholder,
.vs__dropdown-toggle,
.vs__dropdown-menu {
  margin-bottom: 5px;
  text-transform: lowercase;
  font-variant: small-caps;
  text-align: right !important;
  direction: rtl !important;
  padding: 2px;
}

.text-right {
  direction: rtl !important;
  text-align: right !important;
}

.reset {
  all: revert;
}

.vpd-icon-btn {
  margin-bottom: 0px !important;
}

.mp-custom-input-text {
  font-size: 25px;
  direction: ltr;
  text-align: left;
}

.table-responsive {
  overflow-x: auto;
}

.table td, .table th {
  white-space: nowrap;
  //min-height: 50px;
}

th {
  font-weight: initial !important;
}

.highlight {
  background-color: #B2FF59;
}

.bg-white {
  color: initial;
}
</style>
